import { trackEvent as t } from '../track';
import { ProfileName } from './propertyTypes';

export interface ProfileProps {
  '[Profile] Name': ProfileName;
}

export const profile = {
  edit: {
    intiate: (props: ProfileProps) => t('[Profile] [Edit] Initiate', props),
    complete: (props: ProfileProps) => t('[Profile] [Edit] Complete', props),
  },
  page: {
    viewFeed: (props: ProfileProps) => t('[Profile] [Page] View feed', props),
    viewPinned: (props: ProfileProps) => t('[Profile] [Page] View pinned', props),
  },
};
